export default function formatDate(inputDate) {
  // Create a new Date object using the input date string
  const date = new Date(inputDate);

  // Extract month, day, and year
  const month = date.getUTCMonth() + 1; // Month is zero-indexed, so we add 1
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  // Ensure two digits for month and day
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedDay = day < 10 ? `0${day}` : day;

  // Format the date in MM-DD-YYYY format
  const formattedDate = `${formattedMonth}-${formattedDay}-${year}`;

  return formattedDate;
}
